import { SET_BACK_FORWARD_DIRECTORY } from '../../constants/backForward';

const initialState = {
    backForward: {
        back: [],
        forward: []
    }
}

const backForwardReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_BACK_FORWARD_DIRECTORY:
            return {
                backForward: action.payload
            };
        default: 
            return state;
    }
};

export default backForwardReducer;